// partners/my-model
import { getData, postData } from 'src/services/RestApi';
import { formatDecimal, formatQuantity, formatDisplayNote, calculateTotalFuel, formatCode } from 'src/utils/formatters';

/**
 * VIEW
 */
export const getList = async (
  payload, {},
  onEndPoint = () => {},
  onSuccess = () => {},
  onError = () => {},
) => {
  const endPoint = 'api/partner/list';
  onEndPoint(endPoint);

  const { result, error } = await getData(endPoint, payload);
  if (error) return onError(error);

  result.forEach((element) => {
    if (element) {
      const type = element.type?.toUpperCase() || '';
      element.code = `${type}-${element.code}`;
      element.info = formatDisplayNote(element.info);
    }
  });
  return onSuccess(result);
};

export const getCacheList = async (
  payload, {},
  onEndPoint = () => {},
  onSuccess = () => {},
  onError = () => {},
) => {
  const endPoint = 'api/partner/cache/list';
  onEndPoint(endPoint);

  const { result, error } = await getData(endPoint, payload);
  if (error) return onError(error);
  
  return onSuccess(result);
};

export const getItemById = async (payload) => {
  const partnerId = Number(payload?.id) || 0;
  if (partnerId === 0) return {};

  const { result, error } = await getData('api/partner/detail', { partnerId });
  if(error) return {};
  return result;
};

/**
 * FORM
 */
export const apiCreate = async (payload) => {
  const queryData = requestParams(payload);

  return await postData('api/partner/create', queryData);
};

export const apiUpdate = async (payload) => {
  const queryData = requestParams(payload);
  queryData.partnerId = payload.id;

  return await postData('api/partner/edit', queryData);
};

export const apiChange = async (payload) => {
  const queryData = {
    partnerId: payload.id,
    status: payload.status,
  };
  return await postData('api/partner/change', queryData);
};

function requestParams(values) {
  const queryData = {};
  if (values.partnerCode) {
    queryData.code = values.partnerCode;
  }
  if (values.partnerType) {
    queryData.type = values.partnerType;
  }
  if (values.name) {
    queryData.name = values.name;
  }
  if (values.note) {
    queryData.note = values.note;
  }
  return queryData;
}
